import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Pencil, Plus, Trash2, X } from 'lucide-react';

export default function InvoiceTariffDialog({ editing, deleting, busy, error, onChange, onSave, onDelete, onClose }) {
    const dialogRef = useRef(null);
    const firstRef = useRef(null);
    const titleId = useId();
    const descriptionId = useId();
    const isEditing = Boolean(editing?.version);
    const title = deleting ? 'Eliminar tarifa' : isEditing ? 'Editar tarifa' : 'Nueva tarifa';
    const Icon = deleting ? Trash2 : isEditing ? Pencil : Plus;
    useEffect(() => {
        const dialog = dialogRef.current;
        const opener = document.activeElement;
        dialog.showModal();
        firstRef.current.focus();
        return () => { dialog.close(); if (opener?.isConnected) opener.focus(); };
    }, []);
    const change = (key, value) => onChange(previous => ({ ...previous, [key]: value }));

    return createPortal(<dialog ref={dialogRef} className="esave-workspace esave-confirmation esave-tariff-dialog" role={deleting ? 'alertdialog' : 'dialog'} aria-modal="true" aria-labelledby={titleId} aria-describedby={deleting ? descriptionId : undefined} aria-busy={busy}
        onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}>
        <form onSubmit={deleting ? onDelete : onSave}>
            <div className="esave-confirmation-heading">
                <span className="esave-confirmation-icon"><Icon size={23} aria-hidden="true" /></span>
                <h2 id={titleId}>{title}</h2>
                <button type="button" disabled={busy} className="esave-button esave-confirmation-close" aria-label="Cerrar ventana" onClick={onClose}><X size={18} aria-hidden="true" /></button>
            </div>
            <div className="esave-confirmation-body">
                {deleting ? <>
                    <p id={descriptionId}>¿Eliminar esta tarifa del maestro? Las nuevas ofertas volverán a utilizar el nombre original de Neuro.</p>
                    <p className="esave-confirmation-file">{deleting.description}<br /><span className="esave-caption">ID Neuro: {deleting.neuro_id}</span></p>
                    <p className="esave-muted">Las ofertas ya preparadas conservan su texto.</p>
                </> : <>
                    <fieldset disabled={busy} className="esave-fieldset esave-admin-fields">
                        <label className="esave-label">ID Neuro<input ref={isEditing ? undefined : firstRef} className="esave-input" required maxLength={80} pattern="[A-Za-z0-9][A-Za-z0-9_.:\-]{0,79}" readOnly={isEditing} value={editing.neuro_id} onChange={event => change('neuro_id', event.target.value)} /></label>
                        <label className="esave-label">Descripción<input ref={isEditing ? firstRef : undefined} className="esave-input" required maxLength={300} value={editing.description} onChange={event => change('description', event.target.value)} /></label>
                        <label className="esave-checkbox"><input type="checkbox" checked={editing.available_cc} onChange={event => change('available_cc', event.target.checked)} />Disponible CC</label>
                    </fieldset>
                </>}
                {error && <div className="esave-notice" role="alert"><p>{error}</p></div>}
            </div>
            <div className="esave-confirmation-actions">
                <button type="button" ref={deleting ? firstRef : undefined} className="esave-button" disabled={busy} onClick={onClose}>Cancelar</button>
                <button type="submit" disabled={busy} className={`esave-button ${deleting ? 'esave-button-danger' : 'esave-button-primary'}`}><Icon size={16} aria-hidden="true" />{busy ? deleting ? 'Eliminando…' : 'Guardando…' : deleting ? 'Confirmar eliminación' : isEditing ? 'Guardar cambios' : 'Añadir tarifa'}</button>
            </div>
        </form>
    </dialog>, document.body);
}
